import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage } from '../../../helpers';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './AlertModal.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class AlertModal extends Component {
    
    render() {
	  	return (
			<div>
		  		<Modal isOpen={this.props.isModalOpen} toggle={this.toggle}>
		          	<ModalHeader toggle={this.props.toggleAlertModal}>{this.props.modalTitle}</ModalHeader>
		          	{/* <ModalBody
						dangerouslySetInnerHTML={{
							__html: this.props.modalDescription
						}}  
					/> */}
					<ModalBody>
						{this.props.modalDescription}
					</ModalBody>
		          	<ModalFooter className="justify-content-center">
		            	<button 
		            		className="showtix-button showtix-background__grey-1"
                            onClick={this.props.toggleAlertModal}
		            		>{strings.no}</button>
                        <button 
		            		className="showtix-button showtix-background__primary-3"
                            onClick={this.props.confirmAlertModal}
                            disabled={this.props.disabled}
		            		>{strings.yes}</button>    
		          	</ModalFooter>
		        </Modal>
			</div>
	  	);
	}
}

AlertModal.propTypes = {
    modalTitle: PropTypes.string,
    modalDescription: PropTypes.element,
    isModalOpen: PropTypes.bool,
    toggleAlertModal: PropTypes.func,
    confirmAlertModal: PropTypes.func,
}

export default AlertModal;


// WEBPACK FOOTER //
// ./src/components/Common/AlertModal/AlertModal.js